import { IAcquirerSettlement, ISettlementHeader, SettlementType } from "./types";

const DIVIDER = "******************************************";

const pad2 = (n: number): string => n.toString().padStart(2, "0");

const formatBusinessDate = (d: Date): string =>
	`${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;

const formatDateTime = (d: Date): string => {
	const h = d.getHours();
	const ampm = h < 12 ? "am" : "pm";
	const hour12 = h % 12 === 0 ? 12 : h % 12;
	const time = `${pad2(hour12)}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())} ${ampm}`;

	return `${formatBusinessDate(d)} ${time}`;
};

const padLine = (label: string, value: string | number): string => {
	const labelPart = `${label} :`;
	const valuePart = String(value);
	const totalWidth = 42;
	const spaces = Math.max(1, totalWidth - labelPart.length - valuePart.length);

	return `${labelPart}${" ".repeat(spaces)}${valuePart}`;
};

const centsToDollars = (cents: number): string => (cents / 100).toFixed(2);

const formatAcquirerBlock = (a: IAcquirerSettlement): string =>
	[
		padLine("Acquirer", a.ID_SOF_ACQUIRER),
		padLine("Name", a.ID_SOF_NAME),
		padLine("TID", a.ID_DEVICE_TID),
		padLine("MID", a.ID_DEVICE_MID),
		padLine("Sale Count", a.ID_SOF_SALE_COUNT),
		padLine("Sale Total", centsToDollars(a.ID_SOF_SALE_TOTAL)),
		padLine("Refund Count", a.ID_SOF_REFUND_COUNT),
		padLine("Refund Total", centsToDollars(a.ID_SOF_REFUND_TOTAL)),
		padLine("Void Count", a.ID_SOF_VOID_COUNT),
		padLine("Void Total", centsToDollars(a.ID_SOF_VOID_TOTAL)),
	].join("\n");

export function formatSettlementReport(
	type: SettlementType,
	acquirers: IAcquirerSettlement[],
	header: ISettlementHeader,
	now: Date = new Date()
): string {
	const title = type === "creditcard" ? "Credit Card Settlement" : "NETS Settlement";
	const titleCentered = `          ${title}`;

	const head = [
		`Outlet: ${header.outletName}`,
		`Stall ID: ${header.stallId}`,
		`Machine No: ${header.machineNo}`,
		`Business Date: ${formatBusinessDate(now)}`,
		`Date: ${formatDateTime(now)}`,
		DIVIDER,
		titleCentered,
		DIVIDER,
	].join("\n");

	const body = acquirers.map(formatAcquirerBlock).join("\n\n");

	return `${head}\n${body}\n`;
}
